import { lazy } from 'react';

const Add = lazy(() => import('./Add'));
const ArrowDown = lazy(() => import('./ArrowDown'));
const ArrowLeft = lazy(() => import('./ArrowLeft'));
const ArrowRight = lazy(() => import('./ArrowRight'));
const Calendar = lazy(() => import('./Calendar'));
const Check = lazy(() => import('./Check'));
const CurvedArrowDown = lazy(() => import('./CurvedArrowDown'));
const CurvedArrowUp = lazy(() => import('./CurvedArrowUp'));
const Csv = lazy(() => import('./Csv'));
const Edit = lazy(() => import('./Edit'));
const Delete = lazy(() => import('./Delete'));
const Debt = lazy(() => import('./Debt'));
const Derivative = lazy(() => import('./CurvedArrowUp'));
const DesktopUpload = lazy(() => import('./DesktopUpload'));
const Equity = lazy(() => import('./Equity'));
const Error = lazy(() => import('./Error'));
const FileTypeDoc = lazy(() => import('./FileTypeDoc'));
const FileTypePdf = lazy(() => import('./FileTypePdf'));
const FileTypePng = lazy(() => import('./FileTypePng'));
const Help = lazy(() => import('./Help'));
const Info = lazy(() => import('./Info'));
const Mail = lazy(() => import('./Mail'));
const No = lazy(() => import('./No'));
const PaperAirplane = lazy(() => import('./PaperAirplane'));
const Pencil = lazy(() => import('./Pencil'));
const Phone = lazy(() => import('./Phone'));
const QuestionCircleOutlined = lazy(() => import('./QuestionCircleOutlined'));
const Search = lazy(() => import('./Search'));
const Times = lazy(() => import('./Times'));
const Warning = lazy(() => import('./Warning'));
const Yes = lazy(() => import('./Yes'));
const AutoRenew = lazy(() => import('./AutoRenew'));
const OpenFile = lazy(() => import('./OpenFile'));

const Icons = {
  add: <Add />,
  'arrow-down': <ArrowDown />,
  'arrow-left': <ArrowLeft />,
  'arrow-right': <ArrowRight />,
  calendar: <Calendar />,
  check: <Check />,
  'curved-arrow-down': <CurvedArrowDown />,
  'curved-arrow-up': <CurvedArrowUp />,
  csv: <Csv />,
  edit: <Edit />,
  error: <Error />,
  delete: <Delete />,
  debt: <Debt />,
  derivative: <Derivative />,
  'desktop-upload': <DesktopUpload />,
  equity: <Equity />,
  'file-type-doc': <FileTypeDoc />,
  'file-type-pdf': <FileTypePdf />,
  'file-type-png': <FileTypePng />,
  help: <Help />,
  info: <Info />,
  mail: <Mail />,
  no: <No />,
  'paper-airplane': <PaperAirplane />,
  pencil: <Pencil />,
  phone: <Phone />,
  'question-circle-outlined': <QuestionCircleOutlined />,
  search: <Search />,
  times: <Times />,
  warning: <Warning />,
  yes: <Yes />,
  autoRenew: <AutoRenew />,
  openFile: <OpenFile />,
};

export default Icons;
